import TrackItem from "./track-item.component";
import { connect } from 'react-redux';

const mapStateToProps = ({ app }) => ({
  trackCellTarget: app.config?.playback.trackCellTarget,
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackItem);
